const initialState = {
    isOpen: false,
    isActive: false,
};
const modalLogOut = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_LOG_OUT':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalLogOut;
